import { Controller } from '@hotwired/stimulus';
import JSConfetti from 'js-confetti/dist/es';

export default class extends Controller {
  static values = {
    parentSelector: String,
    immediate: Boolean,
    emojis: String,
  };

  get targetableAncestor() {
    if (this.hasParentSelector) {
      return this.element.closest(this.parentSelector);
    }
    return this.element.parentElement;
  }

  initialize() {
    this.fireEffect = this.fireEffect.bind(this);
  }

  connect() {
    if (this.hasImmediateValue && this.immediateValue) {
      requestAnimationFrame(this.fireEffect);
    } else {
      this.targetableAncestor.addEventListener('click', this.fireEffect);
    }
  }

  disconnect() {
    this.targetableAncestor.removeEventListener('click', this.fireEffect);
  }

  fireEffect() {
    const config = {};
    if (this.hasEmojisValue) {
      config.emojis = this.emojisValue.split(',');
    }
    this.confetti = new JSConfetti();
    const { canvas } = this.confetti;
    this.confetti.addConfetti(config).then(() => {
      this.confetti = null;
      canvas.remove();
    });
  }
}
